import "./Payments.scss";
import {useEffect, useState} from "react";
import Loader from "rsuite/Loader";
import PaymentsList from "./components/Payments/PaymentsList";
import axios from "axios";
import {PATHS_API} from "../../../../../enum";
import {useTransfersStore} from "../../../../../modules/profile/transfers/store";
import {usePaymentsStore} from "../../../../../modules/profile/payments/store";

const Payments = () => {
    const [loading, setLoading] = useState(false);
    const payments = usePaymentsStore(state => state.payments)

    return (
         <div className="payments">
             { loading
                 ? <Loader size="md" backdrop />
                 : <PaymentsList resultPayments={payments} />
             }
         </div>
    );
};

export default Payments;